<template>
    <v-dialog
        :value="value"
        @input="$emit('input', $event)"
        max-width="400px"
        :scrollable="scrollable"
    >
        <template
            #activator="{ on }"
            v-if="!noActivator"
        >
            <slot
                :on="on"
                name="activator"
            >
                No Activator
            </slot>
        </template>

        <v-card
            :loading="isLoading"
            :disabled="isLoading"
        >
            <v-card-title>{{ title }}</v-card-title>
            <v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>

            <v-card-text>
                <slot></slot>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    @click="$emit('input', false)"
                    text
                >
                    {{ cancelButton }}
                </v-btn>

                <v-btn
                    v-if="!noOkButton"
                    @click="$emit('ok')"
                    :href="href"
                    text
                    :color="color"
                    :loading="$store.get('loader/loading', loading)"
                    :disabled="okDisabled"
                >
                    {{ okButton }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        scrollable: {
            type: Boolean,
            default: false,
        },
        href: {
            type: String,
        },
        noActivator: {
            type: Boolean,
            default: false,
        },

        value: {
            required: true,
        },

        title: {
            type: String,
            required: true,
        },

        subtitle: {
            type: String,
        },

        cancelButton: {
            type: String,
            default: 'batal',
        },

        color: {
            type: String,
            default: 'primary',
        },

        okButton: {
            type: String,
            default: 'ok',
        },

        loading: {
            type: String,
            default: 'noLoader',
        },

        okDisabled: {
            type: Boolean,
            default: false,
        },

        noOkButton: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        isLoading() {
            return this.$store.get('loader/loading', this.loading)
        },
    },
}
</script>
